import { render } from "./PaymentHistory.vue?vue&type=template&id=4518b2e6&scoped=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"

import "./PaymentHistory.vue?vue&type=style&index=0&id=4518b2e6&lang=less&scoped=true"

import exportComponent from "/root/workspace/school-mobile_yvTP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4518b2e6"]])

export default __exports__